import { Component, OnInit } from '@angular/core';
import { BaseUpdateComponent, BaseDataService, DateRange, ModalService, NotificationService } from 'yt-ng-framework';
import { DeoZaResenjeZaGo } from './deo-za-resenje-za-go';
import { ActivatedRoute } from '@angular/router';
// import { NotificationsService } from 'angular2-notifications';
import { TranslateService } from '@ngx-translate/core';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { RadniDani } from 'src/app/kad.bl/radni-dani/radni-dani';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-deo-za-resenje-za-go-update',
  templateUrl: './deo-za-resenje-za-go-update.component.html'
})

export class DeoZaResenjeZaGoUpdateComponent 
extends BaseUpdateComponent<DeoZaResenjeZaGo> 
implements OnInit {
 
  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationsService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService,
    protected modalService: ModalService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService,modalService);
  }
  
  ngOnInit() {
    super.ngOnInit();

    this.IDProcessed.subscribe((value) => {
  
      if (value && this.Item.ID == -1 && this.ParentProperty) {
        this.baseDataService.GetData('DeoZaResenjeZaGo','DajRbrSledecegDela', this.ParentProperty.Value)
        .subscribe(data => {
          this.baseFormGroup.patchValue({RbrDela: data})
          this.baseFormGroup.get('RbrDela').updateValueAndValidity();

          let dateNow = new Date();
          let date: NgbDate = new NgbDate(dateNow.getFullYear(), dateNow.getMonth() + 1, dateNow.getDate());
          let pp: DateRange ={FromDate: date, ToDate:date};
      
          this.baseFormGroup.patchValue({ Period: pp });
          this.baseFormGroup.get('Period').updateValueAndValidity();          
        })
      }
      
    })
  }

  ngAfterViewInit(){
    setTimeout(()=>{
      this.baseFormGroup.get("Dana").disable();
      this.baseFormGroup.get("DatumPocetkaRada").disable();
    }, 0)
  }

  onDatumChange(value) {
    this.IzracunajBrojDana();
  }

  IzracunajBrojDana(){
    const period:DateRange=this.baseFormGroup.get('Period').value;
    if (period && period.ToDate)
    {
      const d2: NgbDate =period.ToDate;
      if (d2)
      {
        const rd=new RadniDani();
        const d1: NgbDate = period.FromDate;
  
        const dana: number=rd.ngbDajBrojRadnihDana(d1, d2);
        this.baseFormGroup.patchValue({Dana: dana});
        this.baseFormGroup.get('Dana').updateValueAndValidity();
  
        const datumPocetka: NgbDate=rd.ngbDajSledeciRadniDan(d2);
        this.baseFormGroup.patchValue({DatumPocetkaRada: datumPocetka});
        this.baseFormGroup.get('DatumPocetkaRada').updateValueAndValidity();
      }
    }
  }

  editMode:boolean=false;
  SaveMaster(qq){}
  Cancel(){}


}
